<template>
    <div class="account-preferences">

        <!-- Button -->
        <div>
            <button type="button"
                    class="btn text m-l-10"
                    @click="showPreferences"
                    @click.stop=""
            ><span class="fa fa-magic"></span>Account Preferences
            </button>
        </div>


        <!--Modal -->
        <div ref="setter"
             class="modal fade account-preferences-modal"
        >
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Account Preferences</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader">
                            <span class="text-bold">Account {{ account_display_nm }}</span>
                        </div>

                        <app-message-list
                                :form_errors="form_errors"
                        ></app-message-list>

                        <div class="row p-20">
                            <div class="col-sm-5">
                                <button type="button" class="btn btn-xs btn-help pull-right text-uppercase"
                                        style="font-size: 9px;margin-top:2px;" data-toggle="modal"
                                        data-target="#analysis-industry">
                                    Help Me Pick
                                </button>
                                <label>Analysis Industry</label>
                                <select class="form-control col-md-3 fg-line" v-model="industry_id">
                                    <option value=null disabled selected>Select Industry</option>
                                    <option v-for="industry in industry_list" :value="industry.industry_id" v-html="industry.industry_nm">
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-5">
                                <label>Sample Frequency</label>
                                <select class="form-control col-md-3 fg-line" v-model="sampleFreqId" style="text-transform: capitalize">
                                    <option v-for="freq in Object.keys(sampleFreqMap)" :value="sampleFreqMap[freq]" v-html="freq.toLowerCase()">
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row p-20">
                            <div class="col-sm-5">
                                <label>Analysis Packages Allowed:</label>
                                <label class="d-block text-not-bold">
                                    <input type="radio" name="custom_packages_only" :value="true" v-model="custom_packages_only"> Custom packages only
                                </label>
                                <label class="d-block text-not-bold">
                                    <input type="radio" name="custom_packages_only" :value="false" v-model="custom_packages_only"> All packages
                                </label>
                            </div>
                        </div>
                        <div class="row p-20">
                            <div class="col-sm-5">
                                <label>Result Report Grouping:</label>
                                <label class="text-not-bold">
                                    <input type="radio" name="report_by" value="SAMPLE" v-model="report_by"> One report
                                    per sample
                                </label>
                                <label class="text-not-bold">
                                    <input type="radio" name="report_by" value="ORDER" v-model="report_by"> One report
                                    per order
                                </label>
                            </div>
                            <div class="col-sm-6">
                                <label>Who can change this setting:</label>
                                <label class="text-not-bold">
                                    <input type="radio" name="change_by" value="NOT STATIC"
                                           v-model="is_report_by_static"> Anyone who can order analysis
                                </label>
                                <label class="text-not-bold">
                                    <input type="radio" name="change_by" value="STATIC" v-model="is_report_by_static">
                                    Only account administrators
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal">
                            <i class="fa fa-times"></i> Close
                        </button>
                        <button type="button" class="btn btn-lg btn-primary" :class="{disabled : is_retrieving_data }"
                                @click="savePreferences">
                            <i class="fa fa-check"></i> Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Analysis Industry Modal-->
        <div id="analysis-industry" class="modal fade" role="dialog" style="z-index: 1150;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Analysis Industry Help</h4>
                    </div>
                    <div class="modal-body">
                        <div class="modal-subheader">
                            <i class="fa fa-info-circle m-r-5" style="font-size: 1.2em; vertical-align: middle;"></i>
                            <span class="text-bold">Choosing an industry that matches most of your samples will make ordering easier.</span>
                        </div>
                        <div class="modal-scroll-area">
                            <div class="industry-row" @click="industry_id=6"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Agriculture</h3>
                                Select agriculture if your samples will generally consist of the following:
                                <div class="agr">
                                    <span class="label">Soil Fertility</span>
                                    <span class="label">Fertilizer</span>
                                    <span class="label">Plant Tissue</span>
                                    <span class="label">Manure</span>
                                    <span class="label">Compost</span>
                                    <span class="label">Irrigation & Livestock Water</span>
                                    <span class="label">Soil Health</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="industry_id=7"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Environmental</h3>
                                Select environmental if your samples will generally consist of the following:
                                <div class="env">
                                    <span class="label">Drinking Water</span>
                                    <span class="label">Wastewater</span>
                                    <span class="label">Soil</span>
                                    <span class="label">Sludges</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="industry_id=8"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Animal Feed</h3>
                                Select animal feed if your samples will generally consist of the following:
                                <div class="ani">
                                    <span class="label">Finished Feeds</span>
                                    <span class="label">Shell Corn</span>
                                    <span class="label">Forages</span>
                                    <span class="label">Corn Oil</span>
                                    <span class="label">Rations</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="industry_id=9"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Food & Ingredients</h3>
                                Select food if your samples will generally consist of the following:
                                <div class="foo">
                                    <span class="label">Allergens</span>
                                    <span class="label">Nutritional Labeling</span>
                                    <span class="label">GMO</span>
                                    <span class="label">Proximate Analysis</span>
                                    <span class="label">Sponges/Swabs for Pathogen Testing</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="industry_id=10"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Pet Food</h3>
                                Select pet food if your samples will generally consist of the following:
                                <div class="pet">
                                    <span class="label">Wet Pet Food</span>
                                    <span class="label">Dry Pet Food</span>
                                    <span class="label">Pet Treats</span>
                                    <span class="label">Pet Food Ingredients</span>
                                </div>
                            </div>
                            <div class="industry-row gray-row" @click="industry_id=11"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Fuel</h3>
                                Select fuel if your samples will generally consist of the following:
                                <div class="fue">
                                    <span class="label">Ethanol</span>
                                    <span class="label">DDGs</span>
                                    <span class="label">Sulfur Tier III</span>
                                    <span class="label">Canadian</span>
                                    <span class="label">Denaturant</span>
                                    <span class="label">Other</span>
                                </div>
                            </div>
                            <div class="industry-row" @click="industry_id=12"
                                 data-dismiss="modal">
                                <h3 class="industry-title">Nutrient Management</h3>
                                Select nutrient management if your samples will generally consist of the
                                following:
                                <div class="nut-man">
                                    <span class="label">Compost</span>
                                    <span class="label">Fertilizers</span>
                                    <span class="label">Lime</span>
                                    <span class="label">Manure</span>
                                    <span class="label">Growth Media</span>
                                    <span class="label">Irrigation Water</span>
                                    <span class="label">Livestock Suitability</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><i
                                class="fa fa-times"></i> Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .account-preferences {
        display: inline-block;
    }


</style>

<script>
    export default {
        props: {
            account_nbr: "",
            account_display_nm: "",
            industry_list: null,
            current_industry_id: null,
            sampleFreqMap: {},
        },

        data: function() {
            return {
                form_errors: [],
                setter: null,
                custom_packages_only: true,
                report_by: "",
                is_report_by_static: "STATIC",
                preferences: {},
                industry_id: null,
                is_retrieving_data: false,
                sampleFreqId: 1,
            }
        },

        methods: {

            showPreferences: function() {
                this.loadPreferences();
                this.setter.modal('show');
            },

            loadPreferences: function() {
                this.$http.get('/admin/account/preferences',
                    { params : { account_nbr: this.account_nbr }})
                .then(function(response) {
                    this.is_report_by_static = response.data.is_report_by_static;
                    this.report_by = response.data.report_by;
                    this.preferences = response.data.preferences;
                    this.custom_packages_only = response.data.custom_packages_only;
                    this.industry_id = this.current_industry_id;
                    this.sampleFreqId = response.data.sample_freq_id;
                })
            },

            savePreferences: function() {
                this.form_errors = [];
                this.is_retrieving_data=true;
                this.$http.post('/admin/account/preferences', {
                        account_nbr: this.account_nbr,
                        industry_id: this.industry_id,
                        report_by: this.report_by,
                        custom_packages_only: this.custom_packages_only,
                        is_report_by_static: this.is_report_by_static,
                    sample_freq_id: this.sampleFreqId,
                  })
                .then(function(response) {
                    this.$emit('setIndustry', this.industry_id);
                    this.is_retrieving_data=false;
                    this.setter.modal('hide');

                })
                .catch(function(data, status, request){
                    this.form_errors.push(data.body.errors[0])
                    this.is_retrieving_data=false;
                })
            },
            setIndustry: function() {
                this.$emit('setIndustry', this.industry_id);
            }
        },

        mounted: function() {
            var vm = this;
            vm.setter = $(vm.$refs.setter);
            vm.setter.on('hidden.bs.modal', function() { vm.$emit('closed') });
            $('body').append(vm.setter);

        }
    }



</script>




// WEBPACK FOOTER //
// account-preferences.vue?790f0c23